import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconSidebarOff$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconSidebarOff extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '0758012c4882f8d2c61aa2210a42ba0ef27f5dfa', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '0bb41f52c3adf1cdb79ec61e2f74ec52b828f160', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'a6eead521f149533f60df86805f3c0a0ae8e2dd7', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "m19.359 4-16.818.002a.6.6 0 0 0-.285.065.45.45 0 0 0-.19.189C2.024 4.337 2 4.418 2 4.64l.002 12.818a.6.6 0 0 0 .065.285.45.45 0 0 0 .189.19c.081.043.162.066.385.066h16.718c.223 0 .304-.023.385-.067a.45.45 0 0 0 .19-.189c.043-.081.066-.162.066-.385V4.641c0-.223-.023-.304-.067-.385a.45.45 0 0 0-.189-.19C19.663 4.024 19.582 4 19.36 4M3.5 5.5h15v11h-15z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-sidebar-off", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-sidebar-off"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-sidebar-off":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconSidebarOff$1);
            }
            break;
    } });
}

const CosmosIconSidebarOff = CosmosIconSidebarOff$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconSidebarOff, defineCustomElement };
